const roundCurrency = (amount) => Math.round((Number(amount || 0) + Number.EPSILON) * 100) / 100;

export const calculateDroitTimbre = (totalTtc, cardAmount = 0, enabled = true) => {
  if (!enabled) return 0;
  const total = Number(totalTtc || 0);
  const card = Math.max(0, Math.min(Number(cardAmount || 0), total));
  return roundCurrency(Math.max(total - card, 0) * 0.0025);
};

// POS collects the recorded duty from cash, never from the unpaid balance.
export const calculateCollectedDroitTimbre = (totalTtc, cardAmount, cashAmount, enabled = true) =>
  roundCurrency(Math.min(calculateDroitTimbre(totalTtc, cardAmount, enabled), Math.max(0, Number(cashAmount) || 0)));

export const getPosPaymentAmounts = (totalTtc, cashAmount, cardAmount, enabled = true) => {
  const total = roundCurrency(Math.max(0, Number(totalTtc) || 0));
  const cash = roundCurrency(Math.max(0, Number(cashAmount) || 0));
  const card = roundCurrency(Math.max(0, Math.min(Number(cardAmount) || 0, total)));
  const duty = calculateCollectedDroitTimbre(total, card, cash, enabled);
  const keptCash = roundCurrency(Math.min(cash, Math.max(0, total - card + duty)));
  const paidPrincipal = roundCurrency(Math.min(total, card + Math.max(0, keptCash - duty)));
  return { duty, keptCash, paidPrincipal, remaining: roundCurrency(total - paidPrincipal) };
};

export const getReceiptPaymentSummary = (data, enabled = true) => {
  const total = Number(data?.montantTotalTTC || 0);
  const cash = Number(data?.montantKeptCash ?? data?.montantPayeCash ?? data?.montantPayeEspece ?? 0);
  const card = Number(data?.montantPayeCarte || 0);
  // Historical tickets keep their recorded total even when the display is disabled.
  const recordedDuty = Number(data?.montantDroitTimbre || 0);
  const totalDue = total + recordedDuty;
  const explicitPaid = Number(data?.montantPaye || 0);
  const receivedCash = Number(data?.montantPayeCash ?? data?.montantPayeEspece ?? cash);
  const computedPaid = Math.max(cash, receivedCash) + card;
  const paid = explicitPaid > 0 ? Math.max(explicitPaid, computedPaid) : computedPaid;
  const change = Math.max(paid - totalDue, 0);
  return { total, cash, card, paid, change, remaining: Math.max(totalDue - paid, 0), stampDuty: enabled ? recordedDuty : 0, totalDue };
};
